import { SearchDocumentType } from '@wix/client-search-sdk';
export var searchAppSettings = {
    categoryList: {
        key: 'categoryList',
        getDefaultValue: function () {
            var _a;
            return _a = {},
                _a[SearchDocumentType.All] = {
                    index: 100,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a[SearchDocumentType.Products] = {
                    index: 110,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a[SearchDocumentType.Bookings] = {
                    index: 120,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a[SearchDocumentType.Events] = {
                    index: 130,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a[SearchDocumentType.Blogs] = {
                    index: 140,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a[SearchDocumentType.Pages] = {
                    index: 150,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a[SearchDocumentType.Forums] = {
                    index: 160,
                    visible: true,
                    useOverride: false,
                    override: '',
                },
                _a;
        },
    },
};
//# sourceMappingURL=searchAppSettings.js.map